export const TranslateRuleType = (ruleTypes, translate) => {
  try {
    return (ruleTypes || []).map((ruleType) => {
      return { ...ruleType, long_name: translate(`ra.rule_type.${ruleType?.short_name}`) }
    })
  } catch (error) {
    console.log('error', error)
    return ruleTypes || []
  }
}
